import script from "./employee-dashboard-quick-actions.vue?vue&type=script&setup=true&lang=js"
export * from "./employee-dashboard-quick-actions.vue?vue&type=script&setup=true&lang=js"

import "./employee-dashboard-quick-actions.vue?vue&type=style&index=0&id=1b47eecc&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b47eecc"]])

export default __exports__